module.exports = __webpack_public_path__ + "img/prioritas_sameday_dfod_k.f190c6ea.png";